import {useFormik} from "formik";
import {useDispatch, useSelector,} from "react-redux";
import {notification} from "@/store/modules/notification";
import {StoreUtil} from "@/util/store/StoreUtil";
import {workspace} from "@/store/modules/workspace";
import {BaseInput} from "../input/BaseInput";
import {RootState} from "@/store/modules";
import {DeleteWorkSpaceRequest, DeleteWorkSpaceRequestInit} from "@/model/request/workspace/DeleteWorkSpaceRequest.tsx";
import {BaseModal} from "@/components/modal/BaseModal.tsx";
import {base} from "@/store/modules/base.ts";

export default function DeleteWorkSpaceModal() {
    const dispatch = useDispatch<any>();
    const selectedWorkspaceState = useSelector((state: RootState) => state.workspace.selectedWorkspace)
    const workspaceState = useSelector((state: RootState) => state.workspace)
    const authState = useSelector((state: RootState) => state.auth)
    const baseState = useSelector((state: RootState) => state.base)
    const showErrorMessage = (response: any) => {
        StoreUtil.execute(() =>
            dispatch(
                notification.mutation.openModal({
                    type: "error",
                    title: "Error",
                    body: response.responseMessage,
                })
            )
        );
    };

    const showSuccessMessage = (response: any) => {
        StoreUtil.execute(() => {
            dispatch(workspace.action.readWorkSpaceByUserId({userId: authState.userInfo.userId}));
            dispatch(
                notification.mutation.openModal({
                    type: "success",
                    title: "Success",
                    body: response.responseMessage,
                })
            )
            dispatch(base.mutation.resetModalOptions())
        })
    };
    const handleSubmit = async (value: DeleteWorkSpaceRequest) => {
        const request = {
            ...value,
            workspaceId: selectedWorkspaceState.workspaceId,
        };
        await dispatch(
            workspace.action.deleteWorkSpace({
                data: request,
                onSuccess: (response: any) => {
                    showSuccessMessage(response)
                },
                onError: (response: any) => showErrorMessage(response),
            })
        )
        formik.resetForm();
    };
    const workSpaceData = baseState.modalOptions.payload


    const formik = useFormik({
        onSubmit: handleSubmit,
        initialValues: DeleteWorkSpaceRequestInit,
    });
    return (
        <>
            <BaseModal size={"md"} title={`Delete Workspace: ${workSpaceData?.workspaceName}`}
                       subtitle={"Deleting this Workspace removes all applications in this current workspace"}
                       showHeader={true}>
                <div className="workspace-content">
                    <form onSubmit={formik.handleSubmit}>
                        <div className="flex btns">
                            <a className="button is-secondary w-button"
                               onClick={() => dispatch(base.mutation.resetModalOptions())}>Cancel</a>
                            <div className="form-button-wrpper">
                                <BaseInput
                                    type="submit"
                                    formik={formik}
                                    name={"submit"}
                                    value={"Yes, Delete"}
                                    loading={workspaceState.loading}
                                    className={"button w-button"}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </BaseModal>
        </>

    );
}



